// extracted by mini-css-extract-plugin
module.exports = {"NotFoundPage":"styles-module--NotFoundPage--2p7-I","title":"styles-module--title--IXBCZ","link":"styles-module--link--RvxYX"};